export default {
  CART: '/cart',
  MAIN: '/',
  GENEALOGY: '/genealogy',
} as const;
